<template>
  <div>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.go(-1)"></luci-btn-icon>

    <div class="text-xs-center pt-3">
      <i class="material-icons icon">sentiment_very_dissatisfied</i>
      <h1>404 Page Not Found</h1>

      <p class="luci-text">
        The requested URL<span v-if="url" class="font-weight-bold">{{ url }} </span> was not found.
      </p>

      <router-link to="/home">
        <luci-link :config="homeLinkConfig"></luci-link>
      </router-link>
    </div>
  </div>
</template>

<script>
import variables from '../helpers/variables'

export default {
  name: 'PageNotFound',
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions,
      url: null,
      homeLinkConfig: {
        linkText: 'Go to homepage',
        underline: true
      }
    }
  },
  mounted () {
    this.url = this.$router.currentRoute.path
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@pm-connect/luci/dist/scss/luci-variables';

  .icon {
    font-size: 10rem;
    color: $pmc-pink;
  }

  h1 {
    color: $pmc-pink;
    font-weight: bold;
  }
</style>
